<template>
    <div>
        <AlertDismiss ref="alertDismiss"/>
        <ResourceForm/>
        <ResourceDelete/>

        <BaseModal ref="modal" v-model="showModal" size="xl">
            <div v-if="!route" class="text-center text-secondary my-2 align-items-center">
                <b-spinner class="align-middle me-2"></b-spinner>
                <strong>Obteniendo enlace del recurso...</strong>
            </div>
            
             <div v-else>
                <div v-if="isVideo">
                    <VideoPlayer :source="route" />
                </div>
                <div v-else>
                    <DocumentPdf :pdf-url="route" />
                </div>
             </div>
        </BaseModal>


        <b-table :items="items" :fields="fields" class="table-container" sticky-header="48vh">
            <template #cell(options)="data">
                <div class="d-flex align-items-center btn-group">
                    <button class="btn btn-light btn-sm py-0" @click="openResource(data)" v-b-tooltip.hover.left
                        title="Ver recurso">
                        <b-icon :icon="getIcon(data.item)" variant="secondary"></b-icon>
                    </button>

                    <b-button
                        v-permission="'capacitaciones-recurso-eliminar'"
                        @click="toggleDeleteModal(data.item)"
                        type="button"
                        variant="light"
                        v-b-tooltip.hover.left="'Eliminar recurso'"
                        size="sm"
                        class="py-0"
                    >
                        <b-icon icon="trash" variant="secondary"/>
                    </b-button>
                </div>
            </template>>
        </b-table>

        <button
            v-permission="'capacitaciones-recurso-crear'"
            class="btn btn-outline-primary btn-sm" @click="addResource">
            <b-icon icon="plus"/>
            Añadir recurso
        </button>
    </div>
</template>

<script>
import { EventNames } from '@/plugins/enums/index.js'
import AlertDismiss from '@/components/shared/Alert-dismiss.vue';
import BaseModal from '@/components/shared/Base-modal.vue';
import DocumentPdf from '@/components/shared/Document-pdf.vue';
import VideoPlayer from '@/components/shared/Training/Video-player.vue';
import ResourceForm from './ResourceTable/Resource-form.vue';
import ResourceDelete from './ResourceTable/Resource-delete.vue';
import { mapActions } from 'vuex';

export default {
    name: 'Resource-table',

    props: {
        items: Array,
        curriculumId: String,
        courseId: String
    },

    components: {
        BaseModal,
        DocumentPdf,
        AlertDismiss,
        VideoPlayer,
        ResourceForm,
        ResourceDelete
    },

    data() {
        return {
            fields: [
                { key: 'name', label: 'Nombre' },
                { key: 'options', label: '', thClass: 'col-1' }
            ],
            showModal: false,
            route: '',
            name: null
        }
    },

    computed: {
        isVideo() {
            return !this.name.includes('pdf')
        }
    },

    methods: {
        ...mapActions(["getResourceUrl"]),

        async openResource(data) {
            this.name = data.item.name
            this.showModal = true;
            let result = await this.getResourceUrl({ route: data.item.route });
            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message);
                this.showModal = false;
            }

            this.route = result.data;

            this.showModal = true;
        },

        getIcon(item) {
            if (item.name.includes('pdf')) {
                return 'file-earmark-text'
            }

            return 'file-earmark-play'
        },

        addResource() {
            this.$eventBus.$emit(EventNames.OpenResourceFormModal, {curriculumId: this.curriculumId, courseId: this.courseId})
        },
        toggleDeleteModal(item) {
            this.$eventBus.$emit(EventNames.OpenModalDeleteResource, {resource: item, courseId: this.courseId})
        }
    },

    watch: {
        showModal(newValue) {
            if (!newValue) {
                this.route = ''
            }
        }
    }
}
</script>
